 const apiurl = "https://aammiimalaysia.com/admin/api/";


  // const apiurl = "https://aammiimalaysia.banyaninfotech.com/Admin/api/";
 export {apiurl}